"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const BaseStyles = _styledComponents.default.div.withConfig({
  displayName: "BaseStyles",
  componentId: "sc-eid2g7-0"
})(["background-color:transparent;overflow:visible;font-size:14px;color:#000000;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.5;*,:after,:before{box-sizing:border-box;-moz-osx-font-smoothing:grayscale;font-family:'Graphik Web';}p,div,td,span{line-height:inherit;}h1,h2,h3,h4,h5,h6{margin:0;padding:0;}button{border:none;}"]);
var _default = exports.default = BaseStyles;